import { useSelector, shallowEqual } from 'react-redux';
import moment from 'moment';

import { selectGasQuote } from 'state/quote/quote-slice';
import { useMeterType } from 'hooks/useMeterType';
import { selectFuelType } from 'state/fuel-type/fuel-type-slice';
import { useHasSmartMeter } from 'components/direct-sales/quote/hooks/useHasSmartMeter';
import { selectMeterReadPreferences } from 'state/user-preferences/user-preferences-slice';
import { DATE_FORMAT, FUEL_TYPES } from 'config/app-config';
import { useRegistersPayload } from './useRegistersPayload';
import { selectAccountId } from 'state/move-in-date/move-in-date-slice';
import { usePaperLessBilling } from './usePaperLessBilling';

export const useGasMeterPoints = () => {
  const gasQuote = useSelector(selectGasQuote, shallowEqual) || {};
  const { gasMeter = {} } = useMeterType();
  const { hasGasSmartMeter } = useHasSmartMeter();
  const fuelType = useSelector(selectFuelType, shallowEqual);
  const meterReadPreference = useSelector(
    selectMeterReadPreferences,
    shallowEqual
  );
  const ensekAccountId = useSelector(selectAccountId, shallowEqual);
  const today = moment().format(DATE_FORMAT);
  const registers = useRegistersPayload({ fuelType: FUEL_TYPES.GAS });
  const paperlessBilling = usePaperLessBilling();

  const gasMeterPoints = [
    {
      meterType: gasQuote.meterType,
      tariffCode: gasQuote.tariffCode,
      gasSuppliedByBritishGas: false,
      meterPointNumber: gasMeter.meterPointNumber,
      quotedAnnualAmount: gasQuote.annualAmount,
      providedAnnualConsumption: gasQuote.providedAnnualConsumption,
      paperlessBilling: paperlessBilling,
      ...(meterReadPreference.gas && {
        meterReadConsent: meterReadPreference.gas,
        dateOfConsent: today
      }),
      smartMeterOptions: {
        customerHasSmartMeter: hasGasSmartMeter ? 'Y' : 'N',
        customerDecisionToProceed: true
      },
      ensekAccountId,
      ...registers
    }
  ];

  return fuelType.gas ? { gasMeterPoints } : {};
};
